<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">供货计划</span>
                            <RadioGroup
                                v-model="year"
                                @on-change="onYearChange"
                            >
                                <Radio
                                    v-for="(item, index) in yearList"
                                    :key="index"
                                    :label="item"
                                >
                                    <span>{{ item }}年</span>
                                </Radio>
                            </RadioGroup>
                            <Checkbox
                                v-model="existsOnly"
                                @on-change="onShowExistsOnly"
                                style="width: 80px"
                                >只看有供货
                            </Checkbox>
                            <Checkbox
                                v-model="receivedOrder"
                                @on-change="onShowReceivedOrder"
                                style="width: 80px"
                                >显示已接单
                            </Checkbox>
                            <Select
                                v-if="readOnly"
                                v-model="selectedSeedFarmUuid"
                                style="width: 200px; margin-left: 5px"
                                size="small"
                                placeholder="选择苗场"
                                @on-change="onSeedFarmChange"
                                filterable
                            >
                                <Option
                                    v-for="item in seedFarmList"
                                    :value="item.seedFarmUuid"
                                    :key="item.seedFarmUuid"
                                >
                                    {{
                                        item.seedFarmCode +
                                        " " +
                                        item.seedFarmName
                                    }}
                                </Option>
                            </Select>
                            <Input
                                v-model="keyWord"
                                search
                                size="small"
                                enter-button="查询"
                                style="width: 200px; margin-left: 5px"
                                placeholder="小类名称/产品编号/产品名称"
                                @on-search="onSearch"
                            />
                            <Button
                                type="warning"
                                v-if="this.isMainAccount == 1"
                                size="small"
                                icon="md-calendar"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="showModal"
                                >周期选择</Button
                            >
                            <Button
                                type="error"
                                v-if="this.isMainAccount == 1"
                                size="small"
                                icon="md-link"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="showBindindModal"
                                >周数绑定</Button
                            >
                            <Button
                                v-if="!readOnly && isMainAccount == 1"
                                type="success"
                                size="small"
                                icon="ios-checkmark"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="onSave"
                                >保存</Button
                            >
                            <Button
                                type="error"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                ghost
                                @click="onClickImport()"
                                v-if="this.isMainAccount == 1"
                                >导入</Button
                            >
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()"
                                >导出</Button
                            >
                            <Button
                                type="info"
                                size="small"
                                class="success"
                                style="width: 100px"
                                shape="circle"
                                icon="ios-send"
                                @click="onExportByDateRangeShow()"
                                >按周期导出</Button
                            >
                        </div>
                        <div class="right-bar"></div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        ref="mainTable"
                        :columns="mainTable.tableColumns"
                        :data="mainTable.tableData"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getPreSalePlanTableRecord"
                    />
                </Col>
            </Row>
        </Card>
        <Modal v-model="priceModal.show" title="选择价格">
            <RadioGroup v-model="priceModal.preSalePlanPriceIndex">
                <Radio :label="1">
                    <span>{{ "预售价1: ￥" + priceModal.price1 }}</span>
                </Radio>
                <Radio :label="2">
                    <span>{{ "预售价2: ￥" + priceModal.price2 }}</span>
                </Radio>
                <Radio :label="3">
                    <span>{{ "预售价3: ￥" + priceModal.price3 }}</span>
                </Radio>
                <Radio :label="4">
                    <span>{{ "预售价4: ￥" + priceModal.price4 }}</span>
                </Radio>
            </RadioGroup>
            <div slot="footer">
                <Button type="primary" @click="onUpdatePlanPrice">设置</Button>
            </div>
        </Modal>

        <Modal
            v-model="planImportModel.show"
            title="请选择要导入的文件"
            :mask-closable="false"
            @on-ok="onImportPlan"
            :loading="true"
            width="300"
        >
            <div style="display: flex; justify-content: space-between">
                <Upload
                    :show-upload-list="false"
                    :action="UPLOAD_FILE_API"
                    :format="['xlsx','xls']"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError"
                >
                    <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>

                <Button
                    icon="ios-cloud-download-outline"
                    @click="downloadImportTemplate()"
                    >下载模板</Button
                >
            </div>
            <div>{{ planImportModel.fileName }}</div>
        </Modal>
        <component
            :is="lazyWeekModal"
            v-if="weekModalLoaded"
            ref="weekModal"
            @close="onWeekModalClose"
        />

        <component
            :is="lazyWeekBindingModal"
            v-if="weekBindingModalLoaded"
            ref="weekBindingModal"
            @close="onWeekBindingModalClose"
        />

        <component
            :is="lazyExcelExportModal"
            v-if="excelExportModalLoaded"
            ref="excelExportByDateRange"
        />

        <component
            :is="lazyExcelImportModal"
            v-if="excelImportModalLoaded"
            ref="excelImport"
        />
    </div>
</template>

<script>
import search from "@/libs/search";
import { number2ThousandsFormat } from "@/components/number-input/display-format";
import IntegerInput from "@/components/number-input/integer-input";
import CurrencyInput from "@/components/number-input/currency-input";
import { getWeek } from "@/libs/logic";
import {
    getPreSalePlan,
    getPreSalePlanWeeks,
    getWeekConfig,
    getWeekConfigYears,
    getMyPreSalePlan,
    savePreSalePlan,
    importPreSalePlan
} from "@/api/modules/preSale-management/preSale-plan";
import { updateProductPrice } from "@/api/modules/product-management/productPrice-management";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import {
    getSeedFarmList,
    saveSeedFarmWeekBinding
} from "@/api/modules/system-management/seedFarm-management";
import { DOWNLOAD_SERVER, UPLOAD_FILE_API } from "@/api/modules/files";
export default {
    name: "preSale-plan-V2",
    components: {
        StandPaginationTable,
        CurrencyInput,
        IntegerInput
    },
    data() {
        const tableSearch = search.getSearchParams();

        return {
            // 懒加载组件标记
            weekModalLoaded: false,
            weekBindingModalLoaded: false,
            excelExportModalLoaded: false,
            excelImportModalLoaded: false,
            // 防抖搜索
            searchDebounceTimer: null,
            // 年份变更防抖
            yearChangeTimer: null,
            readOnly: false,
            UPLOAD_FILE_API,
            year: 0,
            yearList: [],
            weekConfig: {},
            weekBinding: {},
            checkedWeeks: [],
            mainTable: {
                tableColumns: [],
                tableData: [],
                tableSearch: tableSearch,
                loading: false
            },
            setAmountModal: {
                show: false,
                productUuid: "",
                amount: 0
            },
            keyWord: "",
            seedFarmList: "",
            selectedSeedFarmUuid: "",
            existsOnly: false,
            existsOnlyLast: false,
            receivedOrder: false,
            subQuantity: {},
            productTotalSaleCount: {},
            isMainAccount: 0,
            priceChangeList: [],
            planExportByDateModel: {
                beginYear: "",
                beginWeek: "",
                endYear: "",
                endWeek: "",
                yearList: [],
                yearWeekList: []
            },
            priceModal: {
                show: false,
                preSalePlanUuid: "",
                preSalePlanPriceIndex: 0,
                price1: 0,
                price2: 0,
                price3: 0,
                price4: 0,
                rowIndex: 0,
                planIndex: 0
            },
            planImportModel: {
                show: false,
                loading: false,
                fileWebName: "",
                fileName: ""
            },
            newData: []
        };
    },
    computed: {
        // 懒加载组件
        lazyWeekModal() {
            return () => import("./week-modal");
        },
        lazyWeekBindingModal() {
            return () => import("./week-binding-modal");
        },
        lazyExcelExportModal() {
            return () => import("./excel-export-by-daterange.vue");
        },
        lazyExcelImportModal() {
            return () => import("./excel-import.vue");
        }
    },
    created() {
        if (this.$checkAccessArray(["A", "G", "S", "J", "P"])) {
            this.readOnly = true;
        }

        this.mainTable.tableSearch.limit.conditions.pageLength = 20;
    },
    mounted() {
        this.$nextTick(() => {
            this.initPageData();
        });
    },
    methods: {
        // 初始化页面数据 - 采用异步优化
        async initPageData() {
            try {
                // 并行执行独立的数据获取
                const [seedFarmPromise] = await Promise.all([
                    this.getAllSeedFarmAsync()
                ]);

                // 初始化基本数据
                const date = new Date();
                this.year = date.getFullYear();
                this.yearList = [
                    this.year,
                    this.year + 1,
                    this.year + 2,
                    this.year + 3,
                    this.year + 4
                ];
                this.planExportByDateModel.yearList = [
                    this.year - 2,
                    this.year - 1,
                    this.year,
                    this.year + 1,
                    this.year + 2
                ];
                this.planExportByDateModel.beginYear = this.year;
                this.planExportByDateModel.endYear = this.year;

                // 延迟加载非关键数据
                setTimeout(() => {
                    this.getWeekConfigYears();
                }, 100);

                // 只在非只读模式下初始化数据
                if (!this.readOnly) {
                    setTimeout(() => {
                        this.getPreSalePlanTableRecord(true);
                    }, 50);
                }
            }
            catch (error) {
                console.error("初始化页面数据失败:", error);
            }
        },

        // 异步获取苗场数据
        async getAllSeedFarmAsync() {
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            try {
                const res = await getSeedFarmList(tempSearch);
                if (res.code === 0) {
                    this.seedFarmList = res.data.records;
                }
            }
            catch (error) {
                console.error("获取苗场数据失败:", error);
            }
        },

        // 防抖搜索优化
        onSearch() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.searchDebounceTimer = setTimeout(() => {
                this.executeSearch();
            }, 300);
        },

        executeSearch() {
            let field = "CONCAT(productName, productCode, subCategoryName)";
            search.globalRemoveFilterConditionKey(
                this.mainTable.tableSearch,
                field
            );
            if (this.keyWord) {
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: field,
                    type: "like",
                    value: this.keyWord
                });
            }
            search.globalResetSearch(this.mainTable.tableSearch);
            this.getPreSalePlanTableRecord();
        },

        // 懒加载弹窗组件
        loadWeekModal() {
            if (!this.weekModalLoaded) {
                this.weekModalLoaded = true;
            }
        },

        loadWeekBindingModal() {
            if (!this.weekBindingModalLoaded) {
                this.weekBindingModalLoaded = true;
            }
        },

        loadExcelExportModal() {
            if (!this.excelExportModalLoaded) {
                this.excelExportModalLoaded = true;
            }
        },

        loadExcelImportModal() {
            if (!this.excelImportModalLoaded) {
                this.excelImportModalLoaded = true;
            }
        },

        onClickImport() {
            this.planImportModel.fileName = "";
            this.planImportModel.fileWebName = "";
            this.planImportModel.show = true;
        },
        handleSuccess(res, file) {
            this.planImportModel.fileWebName = res.data.fileList[0].fileUuid;
            this.planImportModel.fileName = res.data.fileList[0].fileName;
        },
        handleFormatError(file) {
            const str = this.format.join(", ");
            this.$Notice.warning({
                title: "文件格式错误",
                desc: "请选择 " + str + " 后缀的文件."
            });
        },
        onImportPlan() {
            importPreSalePlan({
                importFileName: this.planImportModel.fileWebName
            }).then((res) => {
                this.planImportModel.show = false;
                if (res.code === 0) {
                    this.getPlanWeeks();
                    this.$Modal.success({
                        title: "导入成功",
                        content: ""
                    });
                }
            });
        },

        getPriceByIdx() {
            let idx = this.priceModal.preSalePlanPriceIndex;
            switch (idx) {
                case 1:
                    return this.priceModal.price1;
                case 2:
                    return this.priceModal.price2;
                case 3:
                    return this.priceModal.price3;
                case 4:
                    return this.priceModal.price4;
            }
        },

        onSeedFarmChange() {
            if (this.selectedSeedFarmUuid) {
                this.getPlanWeeks();
            }
        },
        onYearChange() {
            // 优化年份变更，使用防抖避免频繁切换
            if (this.yearChangeTimer) {
                clearTimeout(this.yearChangeTimer);
            }
            this.yearChangeTimer = setTimeout(() => {
                this.getPlanWeeksOptimized();
                this.clearData();
            }, 150);
        },
        getPlanWeeks() {
            let curWeek = getWeek();
            this.mainTable.loading = true;
            getPreSalePlanWeeks(this.year, this.selectedSeedFarmUuid).then(
                (res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        res.data.forEach((e) => {
                            this.weekBinding[e.weekSeq] = e.seedFarmWeekBindingName;
                        });

                        let weeks = res.data.map((w) => {
                            return w.weekSeq;
                        });

                        this.$nextTick(() => {
                            if (this.$refs.weekModal) {
                                this.$refs.weekModal.setCheckedWeeks(weeks);
                            }
                        });
                        this.mainTable.loading = true;
                        getWeekConfig(this.year).then((res) => {
                            this.mainTable.loading = false;
                            if (res.code === 0) {
                                res.data.forEach((week) => {
                                    this.weekConfig[week.weekSeq] = week;
                                });

                                let allWeeks = res.data.map((w) => {
                                    return w.weekSeq;
                                });

                                this.$nextTick(() => {
                                    if (this.$refs.weekModal) {
                                        this.$refs.weekModal.initWeeks(
                                            allWeeks
                                        );
                                    }
                                });

                                this.onWeekModalClose(weeks);
                            }
                        });
                    }
                }
            );
        },

        // 周数据获取方法
        async getPlanWeeksOptimized() {
            this.mainTable.loading = true;

            try {
                // 并行执行两个API请求，提升性能
                const [weeksRes, weekConfigRes] = await Promise.all([
                    getPreSalePlanWeeks(this.year, this.selectedSeedFarmUuid),
                    getWeekConfig(this.year)
                ]);

                if (weeksRes.code === 0 && weekConfigRes.code === 0) {
                    // 处理周绑定数据
                    this.weekBinding = {};
                    weeksRes.data.forEach((e) => {
                        this.weekBinding[e.weekSeq] = e.seedFarmWeekBindingName;
                    });

                    // 处理周配置数据
                    this.weekConfig = {};
                    weekConfigRes.data.forEach((week) => {
                        this.weekConfig[week.weekSeq] = week;
                    });

                    const weeks = weeksRes.data.map((w) => w.weekSeq);
                    const allWeeks = weekConfigRes.data.map((w) => w.weekSeq);

                    // 延迟处理DOM操作，避免阻塞
                    this.$nextTick(() => {
                        if (this.$refs.weekModal) {
                            this.$refs.weekModal.setCheckedWeeks(weeks);
                        }
                    });

                    // 延迟执行列生成和数据查询
                    setTimeout(() => {
                        this.onYearChangeWeekModalCloseOptimized(weeks);

                        this.$nextTick(() => {
                            if (this.$refs.weekModal) {
                                this.$refs.weekModal.initWeeks(allWeeks);
                            }
                        });
                    }, 50);
                }
            }
            catch (error) {
                console.error("获取周数据失败:", error);
            }
            finally {
                this.mainTable.loading = false;
            }
        },

        // 优化的周模态关闭方法 - 延迟列生成
        onWeekModalCloseOptimized(weeks) {
            this.checkedWeeks = weeks;

            // 使用requestAnimationFrame优化渲染性能
            requestAnimationFrame(() => {
                this.getColumnsCached();
                this.getPreSalePlanTableRecord();
            });
        },
        onYearChangeWeekModalCloseOptimized(weeks) {
            this.checkedWeeks = weeks;

            // 使用requestAnimationFrame优化渲染性能
            requestAnimationFrame(() => {
                this.getPreSalePlanTableRecord();
            });
        },

        getWeekConfigYears() {
            getWeekConfigYears(this.planExportByDateModel.yearList).then(
                (res) => {
                    if (res.code == 0) {
                        this.planExportByDateModel.yearWeekList = res.data.weekData;
                        this.planExportByDateModel.beginWeek = res.data.curretWeek;
                        let endweeks = res.data.weekData[this.planExportByDateModel.endYear.toString()];
                        this.planExportByDateModel.endWeek = endweeks[endweeks.length - 1];
                    }
                }
            );
        },
        showModal() {
            this.loadWeekModal();
            // 懒加载组件需要更多时间来完成导入和挂载
            this.$nextTick(() => {
                // 使用 setTimeout 确保组件完全挂载
                setTimeout(() => {
                    if (this.$refs.weekModal) {
                        this.$refs.weekModal.showModal(this.year);
                    }
                    else {
                        console.error('weekModal 组件未正确挂载');
                    }
                }, 50);
            });
        },
        showBindindModal() {
            this.loadWeekBindingModal();
            // 懒加载组件需要更多时间来完成导入和挂载
            this.$nextTick(() => {
                // 使用 setTimeout 确保组件完全挂载
                setTimeout(() => {
                    if (this.$refs.weekBindingModal) {
                        this.$refs.weekBindingModal.showModal(this.year);
                    }
                    else {
                        console.error('weekBindingModal 组件未正确挂载');
                    }
                }, 50);
            });
        },
        onWeekBindingModalClose(weeks, bindingName) {
            let weekUuids = Object.values(this.weekConfig)
                .filter((w) => {
                    return weeks.includes(w.weekSeq);
                })
                .map((k) => {
                    return k.weekUuid;
                });

            let data = {
                weekUuids: weekUuids,
                bindingName: bindingName
            };

            this.$Spin.show();
            saveSeedFarmWeekBinding(data).then((res) => {
                this.$Spin.hide();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "设置成功",
                        onOk: () => {
                            this.clearData();
                            // 查询数据
                            this.getPlanWeeksOptimized();
                        }
                    });
                }
            });
        },
        updateProductPrice(productRow) {
            const data = {
                productUuid: productRow.productUuid,
                productTag: `${productRow.productName}（${productRow.productCode}）`,
                productCurSalePriceStatus: productRow.productCurSalePriceStatus,
                productCurSalePrice: productRow.productCurSalePrice,
                productPreSalePriceStatus: productRow.productPreSalePriceStatus,
                productPreSalePrice: productRow.productPreSalePrice,
                productPreSalePrice2: productRow.productPreSalePrice2,
                productPreSalePrice3: productRow.productPreSalePrice3,
                productPreSalePrice4: productRow.productPreSalePrice4
            };

            const submitData = {
                productPrices: [data]
            };
            this.$Spin.show();
            updateProductPrice(submitData)
                .then((res) => {
                    this.$Spin.hide();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "更新成功",
                            content: "",
                            onOk: () => {}
                        });
                    }
                })
                .catch(() => {
                    this.$Spin.hide();
                });
        },
        onWeekModalClose(weeks) {
            this.checkedWeeks = weeks;
            this.getColumnsCached();
            // 查询数据
            this.getPreSalePlanTableRecord();
        },

        getColumns() {
            // 重置表格列
            let defaultColumns = [
                {
                    title: "行号",
                    type: "index",
                    width: 60,
                    align: "center",
                    fixed: "left"
                },
                {
                    title: "产品编码",
                    key: "productCode",
                    align: "center",
                    width: 60,
                    fixed: "left"
                },
                {
                    title: "产品名称",
                    key: "productName",
                    align: "center",
                    width: 80,
                    fixed: "left"
                },
                {
                    title: "预售价",
                    key: "productPreSalePrice",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice = value;
                                    }
                                    this.cellChange(
                                        this.mainTable.tableData[params.index],
                                        "productPreSalePrice1"
                                    );
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价2",
                    key: "productPreSalePrice2",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice2,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice2 = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice2 = value;
                                    }
                                    this.cellChange(
                                        this.mainTable.tableData[params.index],
                                        "productPreSalePrice2"
                                    );
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价3",
                    key: "productPreSalePrice3",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice3,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice3 = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice3 = value;
                                    }
                                    this.cellChange(
                                        this.mainTable.tableData[params.index],
                                        "productPreSalePrice3"
                                    );
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价4",
                    key: "productPreSalePrice4",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice4,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice4 = value;

                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice4 = value;
                                    }
                                    this.cellChange(
                                        this.mainTable.tableData[params.index],
                                        "productPreSalePrice4"
                                    );
                                }
                            }
                        });
                    }
                }
            ];

            const weekSort = this.checkedWeeks.sort((a, b) => {
                return a - b;
            });

            // 优化大量周数据的渲染性能 - 分批处理
            const batchSize = 10; // 每批处理10周
            for (let i = 0; i < weekSort.length; i += batchSize) {
                const batch = weekSort.slice(i, i + batchSize);

                batch.forEach((w) => {
                    const week = this.weekConfig[w];
                    const bindingName = this.weekBinding[w]
                        ? " - " + this.weekBinding[w]
                        : "";
                    const weekBeginEnd = week.weekBeginDate.substr(5) + " ~ " + week.weekEndDate.substr(5);

                    const weekColumn = {
                        title: `第${w}周${bindingName}` + weekBeginEnd,
                        align: "center",
                        renderHeader: (h, { column, index }) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        color: "red"
                                    }
                                },
                                `第${w}周${bindingName}` + weekBeginEnd
                            );
                        },
                        children: [
                            {
                                title: "已接单量",
                                align: "center",
                                width: 80,
                                className: "week-column",
                                render: (h, params) => {
                                    const weekElement = h(
                                        "span",
                                        {
                                            style: {
                                                display: "none"
                                            }
                                        },
                                        params.row.plans[w].totalRemark
                                    );
                                    const weekSaleCountElement = h(
                                        "div",
                                        {
                                            style: {
                                                float: "center"
                                            }
                                        },
                                        params.row.plans[w]
                                            .productTotalSaleCount
                                            ? params.row.plans[w].productTotalSaleCount
                                            : 0
                                    );

                                    return h(
                                        "div",
                                        {
                                            style: {
                                                textAlign: "center"
                                            }
                                        },
                                        [weekElement, weekSaleCountElement]
                                    );
                                }
                            },
                            {
                                title: "可供货量",
                                align: "center",
                                width: 100,
                                className: "week-column",
                                render: (h, params) => {
                                    if (!params.row.plans[w]) {
                                        let zeroItem = {
                                            productUuid:
                                                this.mainTable.tableData[
                                                    params.index
                                                ].productUuid,
                                            week: w,
                                            weekSeq: w,
                                            preSalePlanOfferAmount: 0,
                                            preSalePlanPrice: 0,
                                            preSalePlanPublic: 1,
                                            preSalePlanPriceIndex: 1,
                                            changed: true
                                        };
                                        params.row.plans[w] = zeroItem;
                                        this.mainTable.tableData[
                                            params.index
                                        ].plans[w] = zeroItem;
                                    }
                                    if (
                                        params.row.plans[w]
                                            .preSalePlanPriceIndex === 0
                                    ) {
                                        params.row.plans[
                                            w
                                        ].preSalePlanPriceIndex = 1;
                                        this.mainTable.tableData[
                                            params.index
                                        ].plans[w].preSalePlanPriceIndex = 1;
                                    }
                                    const weekElement = h(
                                        "span",
                                        {
                                            style: {
                                                display: "none"
                                            }
                                        },
                                        params.row.plans[w].totalRemark
                                    );
                                    const priceElement = h(
                                        "a",
                                        {
                                            on: {
                                                click: () => {
                                                    this.priceModal.price1
                                                        = params.row.productPreSalePrice;
                                                    this.priceModal.price2
                                                        = params.row.productPreSalePrice2;
                                                    this.priceModal.price3
                                                        = params.row.productPreSalePrice3;
                                                    this.priceModal.price4
                                                        = params.row.productPreSalePrice4;
                                                    this.priceModal.preSalePlanUuid
                                                        = params.row.plans[
                                                            w
                                                        ].preSalePlanUuid;
                                                    this.priceModal.preSalePlanPriceIndex
                                                        = params.row.plans[
                                                            w
                                                        ].preSalePlanPriceIndex;
                                                    this.priceModal.rowIndex
                                                        = params.index;
                                                    this.priceModal.planIndex
                                                        = w;
                                                    this.priceModal.show = true;
                                                }
                                            }
                                        },
                                        !params.row.plans[w].total
                                            ? "P"
                                                  + params.row.plans[w]
                                                      .preSalePlanPriceIndex
                                            : ""
                                    );

                                    const offerAmountElement = h(IntegerInput, {
                                        props: {
                                            value: params.row.plans[w]
                                                .preSalePlanOfferAmount,
                                            max: 99999999,
                                            size: "small"
                                        },
                                        style: {
                                            display: params.row.plans[w]
                                                .totalPreSalePlanOfferAmount
                                                ? "none"
                                                : "inline",
                                            width: "60px",
                                            float: "right"
                                        },
                                        on: {
                                            change: (val) => {
                                                let changedProduct
                                                    = this.mainTable.tableData[
                                                        params.index
                                                    ];
                                                let changedPlan
                                                    = changedProduct.plans[w];
                                                changedPlan.preSalePlanOfferAmount
                                                    = val;
                                                changedPlan.changed = true;
                                                changedPlan.isChangedQuantity = true;
                                                console.log(
                                                    "CHANGED",
                                                    changedPlan
                                                );
                                                this.cellChange(
                                                    this.mainTable.tableData[
                                                        params.index
                                                    ],
                                                    "preSalePlanOfferAmount",
                                                    w
                                                );
                                            }
                                        },
                                        nativeOn: {
                                            keyup: (e) => {
                                                //按回车，直接跳转到下一输入框
                                                if (e.keyCode === 13) {
                                                    this.getNextFocus(e);
                                                }
                                            }
                                        }
                                    });
                                    const totalAmountElement = h(
                                        "span",
                                        {
                                            style: {
                                                display: !params.row.plans[w]
                                                    .totalPreSalePlanOfferAmount
                                                    ? "none"
                                                    : "inline"
                                            }
                                        },
                                        params.row.plans[w]
                                            .totalPreSalePlanOfferAmount
                                    );
                                    return h(
                                        "div",
                                        {
                                            style: {
                                                textAlign: "center"
                                            }
                                        },
                                        [
                                            //	weekElement,
                                            priceElement,
                                            offerAmountElement,
                                            totalAmountElement
                                        ]
                                    );
                                }
                            }
                        ]
                    };
                    if (!this.receivedOrder) {
                        weekColumn.children = weekColumn.children.filter(
                            (x) => x.title != "已接单量"
                        );
                    }
                    defaultColumns.push(weekColumn);
                });
            }
            this.mainTable.tableColumns = defaultColumns;
        },

        // 优化表格列生成 - 缓存机制
        getColumnsCached() {
            const cacheKey = JSON.stringify({
                year: this.year,
                checkedWeeks: this.checkedWeeks.sort(),
                receivedOrder: this.receivedOrder
            });

            if (this._columnsCache && this._columnsCache.key === cacheKey) {
                this.mainTable.tableColumns = this._columnsCache.columns;
                return;
            }

            this.getColumns();

            this._columnsCache = {
                key: cacheKey,
                columns: this.mainTable.tableColumns
            };
        },
        getNextFocus(e) {
            let parentTdNode
                = e.target.parentNode.parentNode.parentNode.parentNode.parentNode;
            let nextTd = parentTdNode.nextSibling;
            if (nextTd) {
                let cell = nextTd.querySelector(".ivu-input-number-input");
                if (cell) {
                    cell.focus();
                }
            }
            else {
                //换行
                let nextRow = parentTdNode.parentNode.nextElementSibling;
                if (nextRow) {
                    let cell = nextRow.querySelector(".ivu-input-number-input");
                    if (cell) {
                        cell.focus();
                    }
                }
            }
        },
        onShowExistsOnly(value) {
            if (!value) {
                this.getPlanWeeks();
            }

            this.existsOnlyLast = this.existsOnly;
            this.getPreSalePlanTableRecord(false, true);
        },
        onShowReceivedOrder() {
            this.getColumnsCached();
        },
        onExport() {
            const queryData = Object.assign(this.mainTable.tableSearch, {
                year: this.year,
                weeks: this.checkedWeeks,
                seedFarmUuid: this.selectedSeedFarmUuid,
                existsOnly: this.existsOnly,
                needExport: true
            });
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.loading = true;
            getMyPreSalePlan(queryData)
                .then((res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        window.open(
                            DOWNLOAD_SERVER + res.data.exportFileName,
                            "_blank"
                        );
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },

        getPreSalePlanTableRecord(init = false, reset = false) {
            const queryData = {
                ...this.mainTable.tableSearch,
                year: this.year,
                weeks:
                    init
                    || !this.checkedWeeks
                    || this.existsOnly !== this.existsOnlyLast
                        ? []
                        : this.checkedWeeks,
                seedFarmUuid: this.selectedSeedFarmUuid,
                existsOnly: this.existsOnly,
                needExport: false
            };
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            //this.mainTable.tableSearch.limit.enable = true;
            this.mainTable.loading = true;
            getPreSalePlan(queryData)
                .then((res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        this.mainTable.tableData = res.data.records;
                        // 记录当页的商品价格原始信息
                        this.priceChangeList = res.data.records.map((row) =>
                            this.createPriceChangeRecord(row)
                        );
                        this.subQuantity = res.data.subQuantity;
                        this.productTotalSaleCount
                            = res.data.productTotalSaleCount;
                        this.isMainAccount = res.data.isMainAccount;

                        this.handleWeekConfiguration(res.data, init);

                        this.getColumnsCached();

                        this.preSalePlanSum(res.data);

                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        handleWeekConfiguration(data, init) {
            const totalDate = {
                isTotal: true,
                plans: {}
            };

            if (
                init
                || this.existsOnly !== this.existsOnlyLast
                || this.existsOnly == true
            ) {
                this.checkedWeeks = data.weekSeqs;

                data.weeks.forEach((week) => {
                    this.weekConfig[week.weekSeq] = week;
                });

                const allWeeks = data.weeks.map((w) => w.weekSeq);

                data.bindList.forEach((e) => {
                    this.weekBinding[e.weekSeq] = e.seedFarmWeekBindingName;
                });

                this.existsOnlyLast = this.existsOnly;

                this.$nextTick(() => {
                    if (this.$refs.weekModal) {
                        this.$refs.weekModal.setCheckedWeeks(this.checkedWeeks);
                    }
                });

                if (init) {
                    this.$nextTick(() => {
                        if (this.$refs.weekModal) {
                            this.$refs.weekModal.initWeeks(allWeeks);
                        }
                    });
                }
            }
            else {
                // Update existing week configuration
                const existingWeeks = new Set(data.weekSeqs);
                const newWeeks = this.checkedWeeks.filter(
                    (item) => !existingWeeks.has(item)
                );
                this.weekAdd(newWeeks);
            }
        },
        createPriceChangeRecord(row) {
            return {
                productUuid: row.productUuid,
                productTag: `${row.productName}（${row.productCode}）`,
                oldProductPreSalePriceStatus: row.productPreSalePriceStatus,
                newProductPreSalePriceStatus: row.productPreSalePriceStatus,
                oldProductPreSalePrice: row.productPreSalePrice,
                newProductPreSalePrice: row.productPreSalePrice,
                oldProductPreSalePrice2: row.productPreSalePrice2,
                newProductPreSalePrice2: row.productPreSalePrice2,
                oldProductPreSalePrice3: row.productPreSalePrice3,
                newProductPreSalePrice3: row.productPreSalePrice3,
                oldProductPreSalePrice4: row.productPreSalePrice4,
                newProductPreSalePrice4: row.productPreSalePrice4
            };
        },
        // 计算合计
        preSalePlanSum(data) {
            let totalDate = {};
            totalDate.isTotal = true;
            totalDate.plans = {};
            this.checkedWeeks.forEach((week) => {
                const productCount
                    = (data.productTotalSaleCount
                        && data.productTotalSaleCount[week])
                    || 0;
                const offerAmount
                    = (data.subQuantity && data.subQuantity[week]) || 0;
                totalDate.plans[week] = {
                    total: true,
                    productTotalSaleCount: `合计:${productCount}`,
                    totalPreSalePlanOfferAmount: `合计:${offerAmount}`
                };
            });
            console.log(totalDate);
            this.mainTable.tableData.push(totalDate);
        },
        downloadImportTemplate() {
            let url
                = DOWNLOAD_SERVER + "Import/template/plan_import_template.xlsx";
            this.$downLoadFile(url);
        },
        onSave() {
            this.$Spin.show();
            savePreSalePlan({ plan: this.newData })
                .then((res) => {
                    this.$Spin.hide();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            content: ""
                        });
                        this.getPreSalePlanTableRecord();
                    }
                    else {
                        this.getPreSalePlanTableRecord();
                    }
                    this.clearData();
                })
                .catch(() => {
                    this.$Spin.hide();
                });
        },
        updateRow(row) {
            this.params.row.forEach((item) => {
                productPreSalePrice = row.productPreSalePrice;
                productPreSalePrice2 = row.productPreSalePrice;
                productPreSalePrice3 = row.productPreSalePrice;
                productPreSalePrice4 = row.productPreSalePrice;
            });
        },
        onExportByDateRangeShow() {
            this.loadExcelExportModal();
            // 懒加载组件需要更多时间来完成导入和挂载
            this.$nextTick(() => {
                // 使用 setTimeout 确保组件完全挂载
                setTimeout(() => {
                    if (this.$refs.excelExportByDateRange) {
                        this.$refs.excelExportByDateRange.showModal(
                            this.planExportByDateModel.beginYear,
                            this.planExportByDateModel.beginWeek,
                            this.planExportByDateModel.endYear,
                            this.planExportByDateModel.endWeek,
                            this.planExportByDateModel.yearList,
                            this.planExportByDateModel.yearWeekList,
                            this.planExportByDateBeginYearList(),
                            this.planExportByDateBeginWeekList(),
                            this.planExportByDateEndYearList(),
                            this.planExportByDateEndWeekList(),
                            this.mainTable.tableSearch
                        );
                    }
                    else {
                        console.error('excelExportByDateRange 组件未正确挂载');
                    }
                }, 50);
            });
        },
        planExportByDateBeginYearList() {
            if (!this.planExportByDateModel.endYear) {
                return this.planExportByDateModel.yearList;
            }
            else {
                return this.planExportByDateModel.yearList.filter(
                    (item) => item <= this.planExportByDateModel.endYear
                );
            }
        },
        planExportByDateBeginWeekList() {
            if (this.planExportByDateModel.yearWeekList.length < 1) {
                return [];
            }
            let weeks
                = this.planExportByDateModel.yearWeekList[
                    this.planExportByDateModel.beginYear.toString()
                ];
            if (
                this.planExportByDateModel.beginYear
                == this.planExportByDateModel.endYear
            ) {
                return weeks.filter(
                    (item) => item <= this.planExportByDateModel.endWeek
                );
            }
            else {
                return weeks;
            }
        },
        planExportByDateEndYearList() {
            if (!this.planExportByDateModel.beginYear) {
                return this.planExportByDateModel.yearList;
            }
            else {
                return this.planExportByDateModel.yearList.filter(
                    (item) => item >= this.planExportByDateModel.beginYear
                );
            }
        },
        planExportByDateEndWeekList() {
            if (this.planExportByDateModel.yearWeekList.length < 1) {
                return [];
            }
            let weeks
                = this.planExportByDateModel.yearWeekList[
                    this.planExportByDateModel.endYear.toString()
                ];
            return weeks;
        },
        getPriceByIdx() {
            let idx = this.priceModal.preSalePlanPriceIndex;
            switch (idx) {
                case 1:
                    return this.priceModal.price1;
                case 2:
                    return this.priceModal.price2;
                case 3:
                    return this.priceModal.price3;
                case 4:
                    return this.priceModal.price4;
            }
        },
        onUpdatePlanPrice() {
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].preSalePlanPriceIndex = this.priceModal.preSalePlanPriceIndex;
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].preSalePlanPrice = this.getPriceByIdx();
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].changed = true;
            this.priceModal.show = false;
            this.cellChange(
                this.mainTable.tableData[this.priceModal.rowIndex],
                "preSalePlanPriceIndex",
                this.priceModal.planIndex
            );
        },

        // 组件销毁时清理定时器
        beforeDestroy() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
                this.searchDebounceTimer = null;
            }
            if (this.yearChangeTimer) {
                clearTimeout(this.yearChangeTimer);
                this.yearChangeTimer = null;
            }
        },
        weekAdd(weeks) {
            const template = {
                type: 3,
                weekYear: Number(this.year),
                preSalePlanPriceIndex: 0,
                preSalePlanOfferAmount: 0,
                productPreSalePrice: 0,
                productPreSalePrice2: 0,
                productPreSalePrice3: 0
            };

            const newEntries = this.mainTable.tableData.flatMap((a) => {
                return weeks.map((weekWeq) => ({
                    ...template,
                    productUuid: a.productUuid,
                    weekWeq
                }));
            });

            this.newData.push(...newEntries);
        },
        clearData() {
            this.newData.length = 0;
            // 清理列缓存，确保年份切换时重新生成列
            this._columnsCache = null;
        },
        cellChange(row, field, w = 0) {
            const {
                productUuid,
                productPreSalePrice = 0,
                productPreSalePrice2 = 0,
                productPreSalePrice3 = 0,
                productPreSalePrice4 = 0,
                plans = []
            } = row || {};
            if (field === "preSalePlanOfferAmount") {
                const plan = plans[w];
                const productIndex = this.newData.findIndex(
                    (e) =>
                        (e.productUuid === productUuid
                            && e.weekWeq === plan.weekSeq
                            && e.type === 1)
                        || (e.productUuid === productUuid
                            && e.weekWeq === plan.weekSeq
                            && e.type === 3)
                );

                if (productIndex !== -1) {
                    this.newData.splice(productIndex, 1);
                }

                this.newData.push({
                    productUuid: productUuid,
                    type: 1,
                    weekYear: !plan.weekYear ? this.year : plan.weekYear,
                    weekWeq: plan.weekSeq,
                    preSalePlanPriceIndex:
                        Number(plan.preSalePlanPriceIndex) || 0,
                    preSalePlanOfferAmount:
                        Number(plan.preSalePlanOfferAmount) || 0,
                    productPreSalePrice: 0,
                    productPreSalePrice2: 0,
                    productPreSalePrice3: 0,
                    productPreSalePrice4: 0
                });
            }
            else if (field === "preSalePlanPriceIndex") {
                const plan = plans[w];
                const productIndex = this.newData.findIndex(
                    (e) =>
                        e.productUuid === productUuid
                        && e.weekWeq === plan.weekSeq
                        && e.type === 4
                );

                if (productIndex !== -1) {
                    this.newData.splice(productIndex, 1);
                }

                this.newData.push({
                    productUuid: productUuid,
                    type: 4,
                    weekYear: !plan.weekYear ? this.year : plan.weekYear,
                    weekWeq: plan.weekSeq,
                    preSalePlanPriceIndex:
                        Number(plan.preSalePlanPriceIndex) || 0,
                    preSalePlanOfferAmount:
                        Number(plan.preSalePlanOfferAmount) || 0,
                    productPreSalePrice: 0,
                    productPreSalePrice2: 0,
                    productPreSalePrice3: 0,
                    productPreSalePrice4: 0
                });
            }
            else {
                const productIndex = this.newData.findIndex(
                    (e) => e.productUuid === productUuid && e.type === 0
                );

                if (productIndex !== -1) {
                    this.newData.splice(productIndex, 1);
                }

                this.newData.push({
                    productUuid: productUuid,
                    type: 0,
                    weekYear: this.year,
                    weekWeq: 0,
                    preSalePlanPriceIndex: 0,
                    preSalePlanOfferAmount: 0,
                    productPreSalePrice: Number(productPreSalePrice),
                    productPreSalePrice2: Number(productPreSalePrice2),
                    productPreSalePrice3: Number(productPreSalePrice3),
                    productPreSalePrice4: Number(productPreSalePrice4)
                });
            }
        }
    }
};
</script>

<style lang="less">
.week-column /deep/ .ivu-table-cell {
    padding-left: 2px;
    padding-right: 2px;
}

.ivu-table-fixed {
    margin-bottom: 10px !important;
    height: auto !important;
}
</style>
